<template>
<v-layout row wrap justify-center align-center>
    <v-flex xs8 class="mx-auto text-center">
        <h2 class="my-4" v-html="dataAdaptaclima.titulo"></h2>
        <p v-html="dataAdaptaclima.texto">
        </p>

    </v-flex>
    <v-flex xs8 class="mx-auto text-center mt-8">
        <img :src="$store.state.rutaApi+dataAdaptaclima.imagen" alt="logos" width="100%">
    </v-flex>
    
</v-layout>
</template>
<script>
import axios from "axios"
export default {
    data() {
        return {
            dataAdaptaclima:null
        }
    },
    async mounted() {
        await axios
        .get(''+this.$store.state.rutaApi+'adaptaclima')
        .then(response => (this.dataAdaptaclima = response.data[0]))
        // console.log('ddd',this.dataAdaptaclima)
    },
}
</script>